import { gateway } from "../../../../gateway";

export interface ICancelInvoiceResponse {
  status: number;
  message: string;
  data?: { cancelledAt: string };
}

export const cancelInvoiceAction = async (
  invoiceUid: string,
  companyId: number
): Promise<ICancelInvoiceResponse["data"]> => {
  const response = await gateway.patch<ICancelInvoiceResponse>(
    `/invoices/${invoiceUid}/cancel`,
    {},
    {
      headers: {
        "x-company-id": companyId.toString(),
      },
    }
  );
  return response.data?.data;
};
